import * as React from 'react';

function SvgArrowOnboarding(props) {
  return (
    <svg viewBox="0 0 12 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1.293 1.293a1 1 0 011.414 0l8 8a1 1 0 010 1.414l-8 8a1 1 0 01-1.414-1.414L8.586 10 1.293 2.707a1 1 0 010-1.414z" />
    </svg>
  );
}

export default SvgArrowOnboarding;
